<div class="navbar">
    <div class="left-side">
        <div class="left-side-items">
            <img src="../../../assets/img/logo-sem-bold.svg" alt="" srcset="">
        </div>
    </div>
    <div class="right-side">
        <div class="right-side-items">
            <p>Bem vindo(a), {{username}}</p>
        </div>
        <div class="right-side-items">
            <p>
                <img src="../../../assets/img/notifications-icon.svg" alt="" srcset="">
            </p>
        </div>
        <div class="right-side-items">
            <div class="dropdown-custom">
                <p class="dropdown-label" (click) = "onClickDropDown()" (keydown.enter)="onClickDropDown()">
                    <img src="../../../assets/img/avatar-icon.svg" alt="" srcset=""> <i class="fa fa-angle-down ms-1" aria-hidden="true"></i>
                </p>
                <div [ngClass]="(showDropdown) ? 'active' : '' " class="container-dropdown">
                    <div class="triangulo"></div>
                    <p class="itens-dropdown" (click)="privacidadeESeguranca()" (keydown.enter)="privacidadeESeguranca()" >
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        Privacidade e segurança
                    </p>
                    <div class="hr"></div>
                    <p class="itens-dropdown" (click)="sairDoSistema()" (keydown.enter)="sairDoSistema()">
                        <i class="fa fa-sign-out" aria-hidden="true"></i>
                        Sair
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
